export const navLinks = [
  { label: 'Home', to: '/' },
  { label: 'About', to: '/about' },
  { label: 'Service', to: '/service' },
  { label: 'Feature', to: '/feature' },
  { label: 'Advisor', to: '/advisor' },
  { label: 'Review', to: '/review' },
  { label: 'Blog', to: '/blog' },
  { label: 'Contact', to: '/contact' }
];

export const companyDescription = "Goal Path HR Solution is one of the leading HR Service Provider based at Hosur for the past 10 years extending Professional support in HR, IR, Legal compliance, Training & Development to 100+ clients of all sectors, such as Engineering, Ceramics, Granites, Pharma, Garments, Hospitals, Educational Institutions, Food industry etc.";

export const heroSlides = [
  {
    title: 'Fastest Way to Achieve Success',
    subtitle: 'With 10+ years of experience, we provide professional HR support to 100+ clients across all sectors, helping businesses grow and succeed.',
    primaryLabel: 'Get Started',
    secondaryLabel: 'Learn More'
  },
  {
    title: 'Your Success, Our Achievement',
    subtitle: 'Expert guidance in HR, IR, Legal compliance, and Training & Development tailored to your organization\'s unique needs.',
    primaryLabel: 'Get Started',
    secondaryLabel: 'Learn More'
  },
  {
    title: 'Your Business, Our Sincere Effort',
    subtitle: 'Trusted by companies in Engineering, Pharma, Healthcare, and more. We deliver ethical and effective HR solutions.',
    primaryLabel: 'Get Started',
    secondaryLabel: 'Learn More'
  }
];

export const factItems = [
  { title: 'Qualified Team', icon: '🧑‍💼' },
  { title: 'Individual Approach', icon: '🎯' },
  { title: '100% Success', icon: '✅' },
  { title: '100% Satisfaction', icon: '🌟' }
];

export const services = [
  {
    id: 'green-approval',
    category: 'Green Approval',
    color: '#4bc190',
    icon: '🌿',
    preview: ['Drawing approval', 'Licenses / approvals', 'No Objection certificate'],
    allServices: [
      'Drawing approval',
      'Licenses / approvals',
      'No Objection certificate',
      'Consent order - TNPCB'
    ],
    description: 'Environmental and regulatory approvals for industrial operations'
  },
  {
    id: 'licences-approval',
    category: 'Licences & Approval',
    color: '#564787',
    icon: '📋',
    preview: ['Factory License', 'Contract Registration', 'Migration Registration'],
    allServices: [
      'Factory License',
      'Contract Registration',
      'Contract Licence',
      'Migration registration',
      'Migration Licence',
      'Shop Act registration',
      'Fire NOC / Licence',
      'Health NOC / Licence',
      'Running licence - Panchayat / Municipality',
      'Stability certificate',
      'Hoist / Lift certificate',
      'Professional Tax',
      'Labour Welfare fund',
      'Pressure vessel',
      'Certification of Standing orders',
      'Festival holidays approval'
    ],
    description: 'Complete licensing and approval services for regulatory compliance'
  },
  {
    id: 'epf-esi',
    category: 'EPF / ESI',
    color: '#9ad4d6',
    icon: '💼',
    preview: ['UAN creation', 'Employees addition/deletion', 'ECR preparation'],
    allServices: [
      'New code for employer',
      'UAN creation',
      'Employees - addition / deletion',
      'ECR preparation',
      'Challan generation',
      'Claims',
      'KYC updation',
      'Contribution payment'
    ],
    description: 'Employee Provident Fund and Social Security administration'
  },
  {
    id: 'compliance-services',
    category: 'Compliance Services',
    color: '#ff9f43',
    icon: '⚖️',
    preview: ['Code on Wages 2019', 'Industrial Relations Code 2020', 'Code on Social Security 2020'],
    allServices: [
      'Code on Wages 2019',
      'Industrial Relations Code 2020',
      'Code on Social Security 2020',
      'Occupational Safety, Health and Working Conditions Code 2020',
      'Minimum Wages',
      'Payment of wages',
      'Bonus',
      'Equal remuneration',
      'Trade unions',
      'Standing Orders',
      'Industrial Disputes',
      'EPF',
      'ESI',
      'Maternity benefit',
      'Gratuity',
      'Factory drawing',
      'Safety, Health, Welfare',
      'Working conditions',
      'Contract labour',
      'Migrant workers',
      'Returns',
      'Registers',
      'Prevention of Sexual Harassment at Workplace (POSH)',
      'Awareness on POSH',
      'Committees',
      'Enquiry',
      'Annual report'
    ],
    description: 'Statutory compliance and labor law advisory services'
  },
  {
    id: 'hr-audit',
    category: 'HR Audit',
    color: '#10ac84',
    icon: '📊',
    preview: ['Audit check list', 'HR DOCUMENTS', 'Employee Hand book'],
    allServices: [
      'Audit check list',
      'HR DOCUMENTS',
      'Employee Hand book',
      'Trainee',
      'Probation',
      'Confirmation',
      'Promotion',
      'Salary revision',
      'Performance appraisal',
      'Procedure for service conditions for supervisory staff'
    ],
    description: 'Comprehensive HR audit and documentation services'
  },
  {
    id: 'compensation-payroll',
    category: 'Compensation & Pay Roll',
    color: '#ee5a24',
    icon: '💰',
    preview: ['Salary components', 'Salary fixation', 'Pay roll processing'],
    allServices: [
      'Salary components',
      'Salary fixation',
      'Pay roll processing',
      'Competency mapping',
      'Employee satisfaction survey'
    ],
    description: 'Compensation management and payroll processing services'
  },
  {
    id: 'training-development',
    category: 'Training & Development',
    color: '#3742fa',
    icon: '🎓',
    preview: ['Soft skills', 'Technical skills', 'ISO'],
    allServices: [
      'Soft skills',
      'Technical skills',
      'Communication',
      'Leadership',
      'Conflict management',
      'Time management',
      'Supervisory skills',
      'ISO',
      'TPM',
      'TQM',
      'Energy conservation',
      'Plant Safety',
      'Others'
    ],
    description: 'Employee training and skill development programs'
  },
  {
    id: 'industrial-relations',
    category: 'Industrial Relations',
    color: '#2ed573',
    icon: '🤝',
    preview: ['Collective bargaining', 'Long term Wages / Bonus settlement', 'Conciliation proceedings'],
    allServices: [
      'Collective bargaining',
      'Long term Wages / Bonus settlement',
      'Conciliation proceedings',
      'Domestic enquiry',
      'Standing orders certification',
      'Consultation on IR issues'
    ],
    description: 'Industrial relations management and dispute resolution services'
  },
  {
    id: 'other-activities',
    category: 'Other Activities',
    color: '#ff6b6b',
    icon: '🛡️',
    preview: ['Safety audit', 'First aid training', 'Emergency evacuation'],
    allServices: [
      'Safety audit',
      'First aid training',
      'Emergency evacuation',
      'Energy consultation',
      'Plant Safety',
      'Pollution Control Board'
    ],
    description: 'Additional workplace safety and environmental services'
  }
];

export const features = [
  { title: 'Trustworthy Partnership', description: 'A trustworthy HR partner for corporates in alignment with current HR practices.' },
  { title: 'Ethical Solutions', description: 'Ethical and effective HR solutions designed for improvement and growth.' },
  { title: '10+ Years Experience', description: 'A decade of professional support across HR, IR, and legal compliance.' },
  { title: '100+ Clients Served', description: 'Serving 100+ clients across diverse sectors including Engineering, Pharma, and Healthcare.' }
];

export const teamMembers = [
  { id: 1, name: 'Hannah Smith', role: 'Senior Advisor' },
  { id: 2, name: 'Michael Brown', role: 'Business Consultant' },
  { id: 3, name: 'Sara Wilson', role: 'Finance Expert' },
  { id: 4, name: 'Daniel Lee', role: 'Strategy Manager' }
];

export const testimonials = [
  {
    quote: 'The Goal Path HR Solution team helped transform our business plan with clear strategy and thoughtful execution.',
    author: 'Jessica Parker'
  },
  {
    quote: 'Professional consultants who delivered exceptional insights and practical recommendations.',
    author: 'Christopher Dale'
  },
  {
    quote: 'A strong partner that helped our teams move faster and make better decisions.',
    author: 'Nina Roberts'
  }
];

export const blogPosts = [
  {
    title: 'How consultants unlock business value',
    excerpt: 'Discover the key steps consulting teams use to align strategy, operations, and growth in a practical way.'
  },
  {
    title: 'Market research trends for modern enterprises',
    excerpt: 'Learn which data sources and study formats drive better decision-making in 2026.'
  },
  {
    title: 'Scaling operations with process excellence',
    excerpt: 'Proven techniques for streamlining service delivery and minimizing operational waste.'
  }
];

export const contactInfo = {
  address: '123 Street, New York, USA',
  phone: '+012 345 67890',
  email: 'info@example.com'
};
